import React from 'react'
import SignUpForm from './Sign-Up-Form/SignUpForm'
const index = () => {
  return (
    <div style={{marginTop: "120px"}}>
      <SignUpForm/>
    </div>
  )
}

export default index
